import React, { useEffect, useState } from "react";
import { Button, Modal, Container, Form, Row } from "react-bootstrap";

function VerCajaModal({ visitas }) {
  // States del Modal
  const [show, setShow] = useState(false);
  const [caja, setCaja] = useState([]);
  const [fechaDesde, setFechaDesde] = useState(getDate());
  const [fechaHasta, setFechaHasta] = useState(getDate());

  // Handlers para abrir y cerrar.
  const handleClose = () => setShow(false);

  const handleShow = () => {
    filterVisita();
    setShow(true);
  };

  // Funcion encargada de buscar las visitas en efectivo y del dia de la fecha
  function filterVisita() {
    let aux = visitas.filter((visita) => visita.formaDePago == "Efectivo");
    let aux2 = aux.filter(
      (visita) => visita.fecha >= fechaDesde && visita.fecha <= fechaHasta
    );
    setCaja(aux2);
  }

  // Funcion encargada de obtener la fecha de hoy y devolverla formateada.
  function getDate(separator = "-") {
    const newDate = new Date();
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${
      month < 10 ? `0${month}` : `${month}`
    }${separator}${date < 10 ? `0${date}` : `${date}`}`;
  }

  // Esta variable lleva la cuenta del total de los productos
  let total = caja.reduce((sum, value) => sum + parseFloat(value.total), 0);

  // Cuando hay un cambio en los states volvemos a ejecutar la funcion filterVisita
  useEffect(() => {
    filterVisita();
  }, [fechaDesde, fechaHasta]);

  return (
    <>
      <Button variant="info" size="sm" onClick={handleShow}>
        Ver Caja
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header>
          <Modal.Title>Caja en Efectivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Form.Group className="mb-4 col-6">
              <Form.Label>Desde:</Form.Label>
              <Form.Control
                className="pointer"
                type="date"
                value={fechaDesde}
                onChange={(e) => {
                  setFechaDesde(e.target.value);
                }}
              />
            </Form.Group>

            <Form.Group className="mb-4 col-6">
              <Form.Label>Hasta:</Form.Label>
              <Form.Control
                className="pointer"
                type="date"
                value={fechaHasta}
                onChange={(e) => {
                  setFechaHasta(e.target.value);
                }}
              />
            </Form.Group>
          </Row>
          <Container>
            {caja.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th className="col-lg-4">Fecha</th>
                      <th className="col-lg-6">Cliente</th>
                      <th className="col-lg-2">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {caja.map((visita) => {
                      return (
                        <tr key={visita.id_visita} className="table-default">
                          <td>{visita.fecha}</td>
                          <td>
                            {visita.nombre} {visita.apellido}
                          </td>
                          <td>${visita.total}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <h4 className="mt-4 text-info">Total: ${total}</h4>
              </div>
            ) : (
              <h5>No hay pagos en efectivo en el período seleccionado</h5>
            )}
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" size="sm" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default VerCajaModal;
